import { Pipe, PipeTransform } from '@angular/core';
import Constants from '../shared/constants';
import * as moment from 'moment';

@Pipe({ name: 'dateTimeFormat' })
export class DateTimeFormatPipe implements PipeTransform {
    transform(value: Date, args: string[]): any {
        if (!value) { return value; }
        return moment(value).format(Constants.MomentDateTimeFormat);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/pipes/datetime-format.pipe.ts